import React from 'react';
import PropTypes from 'prop-types';

const Avatar = ({circle, children}) => (
  <div
    className="ml-3 mr-2 rounded-circle d-flex justify-content-center align-items-center"
    style={{width: `${circle}px`, height: `${circle}px`, backgroundColor: '#e8eaed', color: '#353e44', fontSize: '0.875rem'}}
  >
    {children}
  </div>
);


Avatar.defaultProps = {
  circle: 24
};

Avatar.propTypes = {
  circle: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};

export default Avatar;
